import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/home.vue')
  },
  {
    path: '/edit',
    name: 'edit',
    component: () => import('@/views/edit.vue'),
    alias: "/erp/edit_index"
  },
  {
    path: '/editView',
    name: 'editView',
    component: () => import('@/views/editView.vue')
  },
  {
    path: '/goodsDetail',
    name: 'goodsDetail',
    component: () => import('@/views/goodsDetail.vue')
  },
  {
    path: '/displayPage/:page',
    component: () => import('@/views/displayPage.vue')
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

export default router
